import React from 'react';

const Icon = ({ size = '28', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 28 28" fill="none" {...other}>
            <path
                d="M14 0C6.268 0 0 6.268 0 14s6.268 14 14 14 14-6.268 14-14S21.732 0 14 0Zm.004 5.833c.41 0 .742.333.742.742v6.682h6.68a.743.743 0 0 1 0 1.485h-6.68v6.682a.742.742 0 0 1-1.485 0v-6.682H6.578a.743.743 0 0 1 0-1.485h6.683V6.575c0-.41.333-.742.743-.742Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
